/**
 * @fileoverview gRPC-Web generated client stub for marginpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require('grpc-web');

var google_type_date_pb = require('../../google/type/date_pb.js');

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
const proto = {};
proto.marginpb = require('./calllog_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.marginpb.CallLogServiceClient = function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;
};

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.marginpb.CallLogServicePromiseClient = function(
  hostname,
  credentials,
  options
) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.ListCallLogRequest,
 *   !proto.marginpb.ListCallLogResponse>}
 */
const methodDescriptor_CallLogService_ListCallLog = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/ListCallLog',
  grpc.web.MethodType.UNARY,
  proto.marginpb.ListCallLogRequest,
  proto.marginpb.ListCallLogResponse,
  /**
   * @param {!proto.marginpb.ListCallLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.ListCallLogResponse.deserializeBinary
);

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.marginpb.ListCallLogRequest,
 *   !proto.marginpb.ListCallLogResponse>}
 */
const methodInfo_CallLogService_ListCallLog = new grpc.web.AbstractClientBase.MethodInfo(
  proto.marginpb.ListCallLogResponse,
  /**
   * @param {!proto.marginpb.ListCallLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.ListCallLogResponse.deserializeBinary
);

/**
 * @param {!proto.marginpb.ListCallLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.marginpb.ListCallLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.ListCallLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.listCallLog = function(
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/marginpb.CallLogService/ListCallLog',
    request,
    metadata || {},
    methodDescriptor_CallLogService_ListCallLog,
    callback
  );
};

/**
 * @param {!proto.marginpb.ListCallLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.ListCallLogResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.listCallLog = function(
  request,
  metadata
) {
  return this.client_.unaryCall(
    this.hostname_ + '/marginpb.CallLogService/ListCallLog',
    request,
    metadata || {},
    methodDescriptor_CallLogService_ListCallLog
  );
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.CallLog,
 *   !proto.marginpb.UpdateCallLogResponse>}
 */
const methodDescriptor_CallLogService_UpdateCallLog = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/UpdateCallLog',
  grpc.web.MethodType.UNARY,
  proto.marginpb.CallLog,
  proto.marginpb.UpdateCallLogResponse,
  /**
   * @param {!proto.marginpb.CallLog} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.UpdateCallLogResponse.deserializeBinary
);

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.marginpb.CallLog,
 *   !proto.marginpb.UpdateCallLogResponse>}
 */
const methodInfo_CallLogService_UpdateCallLog = new grpc.web.AbstractClientBase.MethodInfo(
  proto.marginpb.UpdateCallLogResponse,
  /**
   * @param {!proto.marginpb.CallLog} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.UpdateCallLogResponse.deserializeBinary
);

/**
 * @param {!proto.marginpb.CallLog} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.marginpb.UpdateCallLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.UpdateCallLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.updateCallLog = function(
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/marginpb.CallLogService/UpdateCallLog',
    request,
    metadata || {},
    methodDescriptor_CallLogService_UpdateCallLog,
    callback
  );
};

/**
 * @param {!proto.marginpb.CallLog} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.UpdateCallLogResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.updateCallLog = function(
  request,
  metadata
) {
  return this.client_.unaryCall(
    this.hostname_ + '/marginpb.CallLogService/UpdateCallLog',
    request,
    metadata || {},
    methodDescriptor_CallLogService_UpdateCallLog
  );
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.CallNoticeRequest,
 *   !proto.marginpb.EmptyResponse>}
 */
const methodDescriptor_CallLogService_CallNotice = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/CallNotice',
  grpc.web.MethodType.UNARY,
  proto.marginpb.CallNoticeRequest,
  proto.marginpb.EmptyResponse,
  /**
   * @param {!proto.marginpb.CallNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.EmptyResponse.deserializeBinary
);

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.marginpb.CallNoticeRequest,
 *   !proto.marginpb.EmptyResponse>}
 */
const methodInfo_CallLogService_CallNotice = new grpc.web.AbstractClientBase.MethodInfo(
  proto.marginpb.EmptyResponse,
  /**
   * @param {!proto.marginpb.CallNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.EmptyResponse.deserializeBinary
);

/**
 * @param {!proto.marginpb.CallNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.marginpb.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.callNotice = function(
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/marginpb.CallLogService/CallNotice',
    request,
    metadata || {},
    methodDescriptor_CallLogService_CallNotice,
    callback
  );
};

/**
 * @param {!proto.marginpb.CallNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.callNotice = function(
  request,
  metadata
) {
  return this.client_.unaryCall(
    this.hostname_ + '/marginpb.CallLogService/CallNotice',
    request,
    metadata || {},
    methodDescriptor_CallLogService_CallNotice
  );
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.CallLog,
 *   !proto.marginpb.CreateCallLogResponse>}
 */
const methodDescriptor_CallLogService_CreateCallLog = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/CreateCallLog',
  grpc.web.MethodType.UNARY,
  proto.marginpb.CallLog,
  proto.marginpb.CreateCallLogResponse,
  /**
   * @param {!proto.marginpb.CallLog} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.CreateCallLogResponse.deserializeBinary
);

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.marginpb.CallLog,
 *   !proto.marginpb.CreateCallLogResponse>}
 */
const methodInfo_CallLogService_CreateCallLog = new grpc.web.AbstractClientBase.MethodInfo(
  proto.marginpb.CreateCallLogResponse,
  /**
   * @param {!proto.marginpb.CallLog} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.CreateCallLogResponse.deserializeBinary
);

/**
 * @param {!proto.marginpb.CallLog} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.marginpb.CreateCallLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.CreateCallLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.createCallLog = function(
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/marginpb.CallLogService/CreateCallLog',
    request,
    metadata || {},
    methodDescriptor_CallLogService_CreateCallLog,
    callback
  );
};

/**
 * @param {!proto.marginpb.CallLog} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.CreateCallLogResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.createCallLog = function(
  request,
  metadata
) {
  return this.client_.unaryCall(
    this.hostname_ + '/marginpb.CallLogService/CreateCallLog',
    request,
    metadata || {},
    methodDescriptor_CallLogService_CreateCallLog
  );
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.Empty,
 *   !proto.marginpb.CallLog>}
 */
const methodDescriptor_CallLogService_GetNewId = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/GetNewId',
  grpc.web.MethodType.UNARY,
  proto.marginpb.Empty,
  proto.marginpb.CallLog,
  /**
   * @param {!proto.marginpb.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.CallLog.deserializeBinary
);

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.marginpb.Empty,
 *   !proto.marginpb.CallLog>}
 */
const methodInfo_CallLogService_GetNewId = new grpc.web.AbstractClientBase.MethodInfo(
  proto.marginpb.CallLog,
  /**
   * @param {!proto.marginpb.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.CallLog.deserializeBinary
);

/**
 * @param {!proto.marginpb.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.marginpb.CallLog)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.CallLog>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.getNewId = function(
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/marginpb.CallLogService/GetNewId',
    request,
    metadata || {},
    methodDescriptor_CallLogService_GetNewId,
    callback
  );
};

/**
 * @param {!proto.marginpb.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.CallLog>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.getNewId = function(
  request,
  metadata
) {
  return this.client_.unaryCall(
    this.hostname_ + '/marginpb.CallLogService/GetNewId',
    request,
    metadata || {},
    methodDescriptor_CallLogService_GetNewId
  );
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.GetAccountIdRequest,
 *   !proto.marginpb.CallLog>}
 */
const methodDescriptor_CallLogService_GetAccountId = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/GetAccountId',
  grpc.web.MethodType.UNARY,
  proto.marginpb.GetAccountIdRequest,
  proto.marginpb.CallLog,
  /**
   * @param {!proto.marginpb.GetAccountIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.CallLog.deserializeBinary
);

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.marginpb.GetAccountIdRequest,
 *   !proto.marginpb.CallLog>}
 */
const methodInfo_CallLogService_GetAccountId = new grpc.web.AbstractClientBase.MethodInfo(
  proto.marginpb.CallLog,
  /**
   * @param {!proto.marginpb.GetAccountIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.CallLog.deserializeBinary
);

/**
 * @param {!proto.marginpb.GetAccountIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.marginpb.CallLog)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.CallLog>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.getAccountId = function(
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/marginpb.CallLogService/GetAccountId',
    request,
    metadata || {},
    methodDescriptor_CallLogService_GetAccountId,
    callback
  );
};

/**
 * @param {!proto.marginpb.GetAccountIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.CallLog>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.getAccountId = function(
  request,
  metadata
) {
  return this.client_.unaryCall(
    this.hostname_ + '/marginpb.CallLogService/GetAccountId',
    request,
    metadata || {},
    methodDescriptor_CallLogService_GetAccountId
  );
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.ListCallLogAuditRequest,
 *   !proto.marginpb.ListCallLogAuditResponse>}
 */
const methodDescriptor_CallLogService_ListCallLogAudit = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/ListCallLogAudit',
  grpc.web.MethodType.UNARY,
  proto.marginpb.ListCallLogAuditRequest,
  proto.marginpb.ListCallLogAuditResponse,
  /**
   * @param {!proto.marginpb.ListCallLogAuditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.ListCallLogAuditResponse.deserializeBinary
);

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.marginpb.ListCallLogAuditRequest,
 *   !proto.marginpb.ListCallLogAuditResponse>}
 */
const methodInfo_CallLogService_ListCallLogAudit = new grpc.web.AbstractClientBase.MethodInfo(
  proto.marginpb.ListCallLogAuditResponse,
  /**
   * @param {!proto.marginpb.ListCallLogAuditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.ListCallLogAuditResponse.deserializeBinary
);

/**
 * @param {!proto.marginpb.ListCallLogAuditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.marginpb.ListCallLogAuditResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.ListCallLogAuditResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.listCallLogAudit = function(
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/marginpb.CallLogService/ListCallLogAudit',
    request,
    metadata || {},
    methodDescriptor_CallLogService_ListCallLogAudit,
    callback
  );
};

/**
 * @param {!proto.marginpb.ListCallLogAuditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.ListCallLogAuditResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.listCallLogAudit = function(
  request,
  metadata
) {
  return this.client_.unaryCall(
    this.hostname_ + '/marginpb.CallLogService/ListCallLogAudit',
    request,
    metadata || {},
    methodDescriptor_CallLogService_ListCallLogAudit
  );
};

module.exports = proto.marginpb;
